import { render, staticRenderFns } from "./RiskQuizAgePortfolios.vue?vue&type=template&id=30b08f78"
import script from "./RiskQuizAgePortfolios.vue?vue&type=script&lang=ts"
export * from "./RiskQuizAgePortfolios.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports